import { render, staticRenderFns } from "./rankmatchuserlist.vue?vue&type=template&id=c1cbbf7c&scoped=true"
import script from "./rankmatchuserlist.vue?vue&type=script&lang=js"
export * from "./rankmatchuserlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1cbbf7c",
  null
  
)

export default component.exports